import { useAuth0 } from "@auth0/auth0-react"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import Api from '../../lib/api'

export const useUploadValueList = (key: string, value: any) => {
  const { getAccessTokenSilently } = useAuth0()

  const mutation = useMutation(async (valueListData: any) => {
    const token = await getAccessTokenSilently()
    return await Api.post(`v1/cost-codes/upload`, valueListData, token)
  })
  return mutation
}

export const useUploadCostCodeValueList = (key: string, projectId: string | undefined) => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()
  const mutation = useMutation(async (valueListData: any) => {
    const token = await getAccessTokenSilently()
    return await Api.post(`v1/projects/${projectId}/cost-codes/upload`, valueListData, token)
  }, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['costcodes'] })
    }
  })
  return mutation
}